import Flex from '@Components/Bases/Flex';
import FormSelect from '@Components/Form/FormSelect';
import { disabledFormSelectStyles } from '@Components/Form/styles';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { InputLabel, MenuItem, Typography } from '@mui/material';

type OtherGreenhouseGasScopeProps = {
  options: IInfoCategoryMasterData[];
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const OtherGreenhouseGasScope = ({
  options,
  isCompletedTh,
  isCompletedEn,
}: OtherGreenhouseGasScopeProps) => (
  <>
    <Typography fontWeight="bold">ขอบเขตการปล่อยก๊าซเรือนกระจก</Typography>
    <Flex gap={2} my={2} alignItems="center" justifyContent="end">
      <InputLabel required sx={{ textAlign: 'end', minWidth: '350px' }}>
        ขอบเขตการปล่อยก๊าซเรือนกระจก
      </InputLabel>
      <FormSelect
        name="scopeId"
        placeholder="โปรดเลือก"
        sx={
          isCompletedTh || isCompletedEn ? disabledFormSelectStyles : undefined
        }
        displayEmpty
        renderValue={(selected) =>
          options.find((option) => option.id === selected)?.nameTh ||
          'โปรดเลือก'
        }
      >
        {options.map(({ id, nameTh }) => (
          <MenuItem key={id} value={id}>
            {nameTh}
          </MenuItem>
        ))}
      </FormSelect>
    </Flex>
  </>
);

export default OtherGreenhouseGasScope;
